const state = {
    containerTimeFields: [
        {
            key: "process",
            label: "作業",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "car_no",
            label: "車別",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "start_time",
            label: "開始時間",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "end_time",
            label: "結束時間",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "total_time",
            label: "出貨時間",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        }
    ],
    containerTimeItem: [
        // {
        //     process: '出貨',
        //     car_no: "A1",
        //     start_time: '2021-09-28 16:00:05',
        //     end_time: '-',
        //     total_time: '5小時25分30秒',
        // },
    ],
}
const getters = {
    get_containerTimeFields: state => {
        return state.containerTimeFields
    },
    get_containerTimeItem: state => {
        return state.containerTimeItem
    },
}
const actions = {
    set_containerTimeFields(context, array) {
        context.commit('SET_CONTAINERTIMEFIELDS', array);
    },
    set_containerTimeItem(context, array) {
        context.commit('SET_CONTAINERTIMEITEM', array);
    },
    clear_containerTimeItem(context) {
        context.commit('CLEAR_CONTAINERTIMEITEM');
    },
}
const mutations = {
    SET_CONTAINERTIMEFIELDS(state, array) {
        state.containerTimeFields = array;
    },
    SET_CONTAINERTIMEITEM(state, array) {
        state.containerTimeItem = array;
    },
    CLEAR_CONTAINERTIMEITEM(state) {
        state.containerTimeItem = [];
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/containerTime.js